<template>

  <div class="proHero" id="proHero1">
    <video id="proHeroVideo1" 
        src="https://mis-lynx.mis-implants.com/lynx/img/lynx.mp4" 
        playsinline 
        data-src="" 
        poster="" 
        title="" 
        autoplay 
        loop
        muted>            
    </video>        
    <div class="proHeroCont">
        <slot></slot>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    sectionData:{} 
  },  
  data() {
    return {
        //
        loadedData:[],
        timerInt:null,
        timerCounter:0,
        hoverIndex:0,      
    };
  },
  mounted() {
    var vm = this;
    this.$nextTick(function() {
      vm.initVideoEvents();
    });
    //this.loadHeroItems();    
  },
  watch: {
  },
  computed: {
  },
  methods: 
  {

  }
};
</script>

<style scoped>
    .proHero
    {
        display: block;
        position: relative;
        height: auto;
        overflow: hidden;
        width: 100%;
        height: 100%;
    }

    .proHero video
    {
        object-fit: fill;
        width: 100%;
        height: 100%;
    }
    .proHeroCont
    {
        position: absolute;
        top: 0px;
        height: 100%;
        width: 100%;
        text-align: left;
        display: flex;
        align-content: center;
        align-items: center;
    }


  /* ----------- mobile ----------- */
  @media screen and (max-width: 815px) {
    .proHero
    {
      padding-bottom: 0px !important;
    }

  }    


    /* Portrait */
    @media only screen 
      and (min-width: 1024px) 
      and (max-height: 1366px) 
      and (orientation: portrait) 
      and (-webkit-min-device-pixel-ratio: 1.5) 
      {
      }    

    /* iPad pro Landscape */
    /* Declare the same value for min- and max-width to avoid colliding with desktops */
    /* Source: https://medium.com/connect-the-dots/css-media-queries-for-ipad-pro-8cad10e17106*/
    @media only screen 
      and (min-width: 1024px) 
      and (max-height: 1366px) 
      and (min-height: 1024px) 
      and (orientation: landscape) 
      and (-webkit-min-device-pixel-ratio: 1.5) 
      {
      }

    /* large screens */
    @media only screen and (min-width:2400px)
    {
    }

</style>
